module.exports = __webpack_public_path__ + "static/media/chess-knight-alt.e94ecfd1.svg";